import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage'; // Always loaded — this is what customers see
import ProtectedRoute from './components/ProtectedRoute';
import { CMSProvider } from './context/CMSContext';
import { AuthProvider } from './context/AuthContext';
import './App.css';

// Lazy-loaded: these only download when someone navigates to their route
const AdminPage = lazy(() => import('./pages/AdminPage'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const LoginPage = lazy(() => import('./pages/LoginPage'));

function AppContent() {
  const location = useLocation();
  const cmsScope = location.pathname.startsWith('/admin') ? 'admin' : 'public';

  return (
    <AuthProvider>
      <CMSProvider key={cmsScope}>
        <div className="app">
          <Suspense fallback={<div className="flex items-center justify-center min-h-screen text-gray-500">Loading...</div>}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/*" element={<HomePage />} />
            </Routes>
          </Suspense>
        </div>
      </CMSProvider>
    </AuthProvider>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
